import {FilemanagerApi, getRequest, saveRequest} from '@requests';
import {
    loadingApplication,
    addNotification,
    resendZajavlsIfExistsNotification,
} from '@componentDP/js_react/redux/actions/application';
import {collectFileIdsFromDocuments, postProcessingFileSave, preProcessingFilesSave} from '@services/filemanager';
import {isEmpty} from 'lodash';
import {filesInfoReceived} from '@componentDP/js_react/redux/actions/files';
import {store} from '../store/index';
import {
    IDENTITY_DOCUMENT,
    LOADED_IDENTITY_DOCUMENT,
    LOADING_IDENTITY_DOCUMENT,
    SCHEME_IDENTITY_DOCUMENT,
} from '../store/actionTypes';

export function initializationIdentityDocument() {
    return (dispatch) => {
        const {apiDomainVikon, loadedIdentityDocument, apiDomainFilemanager} = store.getState();
        if (!loadedIdentityDocument) {
            dispatch(setLoadingIdentityDocument(true));
            const chainPromises = [
                getRequest(`${apiDomainVikon}api/digital_profile/document_schemes/1`),
                getRequest(`${apiDomainVikon}api/digital_profile/applicant/identity_main_document`),
            ];
            Promise.all(chainPromises).then((values) => {
                const [schemeIdentityDocument, identityDocument] = values;
                if (!schemeIdentityDocument.errors) {
                    dispatch(setSchemeIdentityDocument(schemeIdentityDocument));
                }
                if (!identityDocument.errors) {
                    dispatch(setIdentityDocument(identityDocument));
                }
                let fileIds = collectFileIdsFromDocuments([identityDocument]);
                if (typeof identityDocument.parent_identity !== 'undefined') {
                    fileIds = fileIds.concat(collectFileIdsFromDocuments([identityDocument.parent_identity]));
                }
                if (!isEmpty(fileIds)) {
                    const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
                    filemanagerApi.getFilesInfo(fileIds)
                        .then((result) => {
                            dispatch(filesInfoReceived(result));
                            dispatch(setLoadingIdentityDocument(false));
                            dispatch(setLoadedIdentityDocument(true));
                        });
                } else {
                    dispatch(setLoadingIdentityDocument(false));
                    dispatch(setLoadedIdentityDocument(true));
                }
            });
        }
    };
}
export function saveIdentityDocument(data, t) {
    return async (dispatch) => {
        dispatch(loadingApplication(true));
        const {apiDomainVikon, apiDomainFilemanager} = store.getState();
        let [idsForSave, idsForDelete, afterSuccessSaveCallback] = preProcessingFilesSave(data);
        let afterSuccessSaveCallbackParentIdentity = null;
        if (typeof data.parent_identity !== 'undefined') {
            const [idsForSaveParentIdentity, idsForDeleteParentIdentity, afterSuccessSaveCallback] = preProcessingFilesSave(data.parent_identity);
            idsForSave = idsForSave.concat(idsForSaveParentIdentity);
            idsForDelete = idsForDelete.concat(idsForDeleteParentIdentity);
            afterSuccessSaveCallbackParentIdentity = afterSuccessSaveCallback;
            data.parent_identity = JSON.stringify(data.parent_identity);
        }
        const savedIdentityDocument = await saveRequest(
            `${apiDomainVikon}api/digital_profile/applicant/identity_main_document`,
            data,
        );
        if (!savedIdentityDocument.errors) {
            dispatch(setIdentityDocument(savedIdentityDocument));
            dispatch(resendZajavlsIfExistsNotification());
            dispatch(addNotification({message: t('saved'), type: 'success'}));
            await postProcessingFileSave(idsForSave, idsForDelete, afterSuccessSaveCallback, apiDomainFilemanager);
            if (afterSuccessSaveCallbackParentIdentity && typeof afterSuccessSaveCallbackParentIdentity === 'function') {
                afterSuccessSaveCallbackParentIdentity();
            }
        } else {
            dispatch(addNotification({message: savedIdentityDocument.errors, type: 'error'}));
        }
        dispatch(loadingApplication(false));
    };
}
export function setSchemeIdentityDocument(object) {
    return {
        type: SCHEME_IDENTITY_DOCUMENT,
        object,
    };
}
export function setIdentityDocument(object) {
    return {
        type: IDENTITY_DOCUMENT,
        object,
    };
}
export function setLoadingIdentityDocument(status) {
    return {
        type: LOADING_IDENTITY_DOCUMENT,
        status,
    };
}
export function setLoadedIdentityDocument(status) {
    return {
        type: LOADED_IDENTITY_DOCUMENT,
        status,
    };
}
